import { render } from "./trueOrFalse.vue?vue&type=template&id=cc2ef61e&scoped=true"
import script from "./trueOrFalse.vue?vue&type=script&lang=js"
export * from "./trueOrFalse.vue?vue&type=script&lang=js"

import "./trueOrFalse.vue?vue&type=style&index=0&id=cc2ef61e&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2ef61e"]])

export default __exports__